export enum FamilyStatus {
Single,
Married,
Divorced,
Widowed,
}
